function Booking() {
	this.build();
}

Booking.prototype.build = function () {
	const that = this;

	$('.booking-select .booking-card').on('click', function () {
		$('.booking-forms .booking-form').fadeOut();
		$('.booking-forms .booking-form[data-booking-id=' + $(this).data('booking-id') + ']').fadeIn();
		$('.booking-select .booking-card').removeClass('active');
		$(this).addClass('active');
		$('.lodging-name').html($(this).find('.name').html());
		document.querySelector('.booking-forms').scrollIntoView({behavior: 'smooth'});
	});

	const params = new URLSearchParams(window.location.search);
	const giteID = params.get('gite');
	if (giteID) {
		const bookingCard = $('.booking-select .booking-card[data-booking-id="' + giteID + '"]');
		bookingCard.addClass('active');
		$('.lodging-name').html(bookingCard.find('.name').html());
		$('.booking-forms .booking-form[data-booking-id=' + giteID + ']').fadeIn();
	}
};
